module.exports = __webpack_public_path__ + "img/qrcode.1fb1ac7e.png";